<script setup lang="ts">
import { LayoutBox } from ".";
interface Props {
  message: string;
}

defineProps<Props>();
</script>
<template>
  <LayoutBox class="flex items-center justify-start gap-6 px-4 py-6 shadow-lg">
    <span class="text-primary w-12"><i class="fa-light fa-circle-notch fa-3x fa-spin"></i></span>
    <span class="text-2xl whitespace-nowrap">{{ message }}</span>
  </LayoutBox>
</template>
